import React, { useEffect, useRef, useState } from 'react'

import axios from "axios";
import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import '../Leads/Leads.css'
import { Tooltip } from 'primereact/tooltip';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Api } from '../../../services/api';
import { useFormik } from 'formik';
import moment from 'moment';
import { Dialog } from 'primereact/dialog';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { CommonService } from '../../../services/commonService';
import LeadModel from '../Leads/LeadModel';
import { BiPlusMedical } from 'react-icons/bi';
import { FaFileExcel } from 'react-icons/fa';
import { PiPaletteBold } from 'react-icons/pi';

const Actives = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState(0);
  const [globalFilter, setGlobalFilter] = useState('');
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);


  const [isLoading, setIsLoading] = useState(true);
  const [leads, setLeads] = useState([]);
  const [selectedYear, setSelectedYear] = useState({ name: 'ALL', code: 'ALL' });
  const [showYear, setShowYear] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [type, setType] = useState('Add');

  const [editLeadList, seteEditLeadList] = useState([]);
  const [leadsId, setLeadsId] = useState(null);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);
  const [projectDeletetitle, setProjectDeleteTitle] = useState('Are you sure you want to delete this lead?');

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    client: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },

  });
  const [colorPlatedailog, setColorPlatedailog] = useState(false);

  const openModal = () => {
    setType('Add');
    seteEditLeadList([]);
    setIsModalOpen(true);

  };

  // -------------------------
  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(leads);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      saveAsExcelFile(excelBuffer, 'active_leads_' + showYear + '_');
    });
  };
  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
          type: EXCEL_TYPE
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };
  // -------------------------


  const yearList = [
    { name: 'ALL', code: 'ALL' },
    { name: '2024', code: '2024' },
    { name: '2023', code: '2023' },
    { name: '2022', code: '2022' },
    { name: '2021', code: '2021' },

  ];
  const toast = useRef(null);
  useEffect(() => {
    setIsLoading(false)
    getListData('ALL');

  }, []);


  const getListData = async (year) => {

    // https://leadtracker.lidaconstruction.ca/api/leads/getall
    setIsLoading(true);
    var _body = {
      year: year
    }
    fetch(Api.API_BASE_URL + 'leads-tracker/active', {
      method: "POST",

      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        setLeads(response.result);
        setIsLoading(false);
        setTotalRecords(response.totalRecords);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });




  }



  const editCopyModal = (rowData, colType) => {

    var baseUrl = Api.API_BASE_URL + 'leads-tracker/leads-getDataByiD/' + rowData.id



    axios.get(baseUrl)
      .then((response) => {
        // toast.current.show({ severity: 'success', detail: response.data.result, life: 3000 });
        // getListData();
        // setIsDeleteConfirmationModalOpen(false);
        seteEditLeadList(response.data.result);
        setIsModalOpen(true);


        setType(colType);
        setIsModalOpen(true);

      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
    // ----------------------------



  };


  const handleDeleteProject = (rowData) => {
    console.log('rowData');
    console.log(rowData);
    setLeadsId(rowData);
    setIsDeleteConfirmationModalOpen(true);
  };


  const confirmDelete = async () => {
    var baseUrl = Api.API_BASE_URL + 'leads-tracker/leads-delete/' + leadsId


    axios.get(baseUrl)
      .then((response) => {
        toast.current.show({ severity: 'success', detail: response.data.result, life: 3000 });
        getListData();
        setIsDeleteConfirmationModalOpen(false);

      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
  }


  const handleHoldProject = (rowData) => {
    console.log('rowData');
    console.log(rowData);
    setLeadsId(rowData);
    setIsDeleteConfirmationModalOpen(true);
  };

  const confirmHold = async (id) => {
    var baseUrl = Api.API_BASE_URL + 'leads-tracker/status-change-leads/' + id


    axios.get(baseUrl)
      .then((response) => {
        toast.current.show({ severity: 'success', detail: response.data.result, life: 3000 });
        getListData();
        // setIsDeleteConfirmationModalOpen(false);

      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
  }

  // -----------------------------------------------------------------------

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>

        <div>
          <FaPencilAlt title='Edit Leads' onClick={() => editCopyModal(rowData, 'Edit')} style={{ marginRight: '15px' }} />
          <FaTrash title='Delete Leads' onClick={() => handleDeleteProject(rowData.id)} style={{ color: 'darkred', marginRight: '15px' }} />
          {/* <AiOutlinePauseCircle    onClick={() => confirmHold(rowData.id)}  /> */}
        </div>
        {/* <Button icon="pi pi-pencil" rounded outlined style={{ width: '40px', height: '40px' }} className="mr-2" onClick={() => editCopyModal(rowData, 'Edit')} /> */}
        {/* <Button icon="pi pi-trash" rounded outlined style={{ width: '40px', height: '40px', }} severity="danger" className="mr-2" onClick={() => handleDeleteProject(rowData.id)} /> */}
      </React.Fragment>
    );
  };
  const rowClass = (data) => {

    return {
      'default': true,
      'site-visits-bg': data.site_visit_stage === 'SITE VISITS',
      'lost-bg': data.declined_type === 'LOST',
      'NOT-PROCEEDING-bg': data.declined_type === 'NOT PROCEEDING',
      'NOT-PROCEEDING-FSA-bg': data.declined_type === 'NOT PROCEEDING FSA',
      'TURNED-DOWN-bg': data.declined_type === 'TURNED DOWN',
      'CE-bg': data.ce_stage === 'CE',
      'FSA-bg': data.fsa_stage === 'FSA',
      'CONTRACT-bg': data.contract_stage === 'CONTRACT',
      'CONSTRUCTION-START-bg': data.construction_start_stage === 'CONSTRUCTION START',

    };
  };

  const showTooltip = (row) => {

    if (row == null || row == '' || row == 'undefined' || row == '0') {
      return '';
    }
    if (typeof row != 'string') {
      row = row.toString();
    }
    var modifiedString = row.substring(0, 50);
    return (
      <span title={row}>
        {modifiedString}
      </span>
    );
  };
  const dateView = (date) => {
    if (date == null || date == '' || date == '0000-00-00' || date == '0000-00-00 00:00:00') {
      return '';
    }
    const parsedDate = new Date(date);
    const year = parsedDate.getFullYear();
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const day = parsedDate.getDate().toString().padStart(2, '0');

    const newFormattedDate = `${year}-${month}-${day}`;

    return newFormattedDate;
  }
  const onGlobalFilterChange = (event) => {
    const value = event.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
  };


  const closeLeadModel = () => {
    console.log("close test ")
    setIsModalOpen(false);
  }


  const handleDataRefreshLeadModel = () => {
    setIsModalOpen(false);
    console.log('Data refreshed!');
    getListData(showYear);
  };

  /// serverSide end 

  // const fetchData = async (event) => {
  //   const { first, rows } = event;
  //   setFirst(first);
  //   setRows(rows);
  //   if (sortOrder == 0) {
  //     setSortOrder(1)
  //   } else {
  //     setSortOrder(0)
  //   }


  //   setLoading(true);
  //   const params = {
  //     start: event.first,
  //     length: event.rows,
  //     search: globalFilter,
  //     order: event.sortField,
  //     orderDir: sortOrder == 1 ? 'ASC' : 'DESC',
  //     year: showYear,

  //   };

  //   try {
  //     const response = await axios.get(Api.API_BASE_URL + 'leads-tracker/active-datatable-server-side', { params });
  //     setLeads(response.data.data);
  //     setTotalRecords(response.data.totalRecords);
  //   } catch (error) {
  //     console.error('Error fetching data', error);
  //   }

  //   setLoading(false);
  // };

  const fetchData = async (event) => {
    const { first, rows, sortField, sortOrder } = event;
    setFirst(first);
    setRows(rows);
    setSortField(sortField);
    setSortOrder(sortOrder);
  
    setLoading(true);
  
    console.log('Event: ', JSON.stringify(event));
    console.log('Fetching data with sortOrder: ', sortOrder);

    const params = {
      start: first,
      length: rows,
      search: globalFilter,
      order: sortField,
      orderDir: sortOrder === 1 ? 'ASC' : 'DESC',
      year: showYear,
      status: 1,
    };
  
    try {
      const response = await axios.get(Api.API_BASE_URL + 'leads-tracker/active-datatable-server-side', { params });
      setLeads(response.data.data);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error('Error fetching data', error);
    }
    setLoading(false);
  };  

  const onSearchFetchData = async (searchValue) => {
    console.log('sortOrder-', sortOrder)
    setGlobalFilter(searchValue)

    setLoading(true);
    const params = {
      start: 0,
      length: 10,
      search: searchValue,
      order: '',
      orderDir: 'ASC',
      year: showYear,

    };

    try {
      const response = await axios.get(Api.API_BASE_URL + 'leads-tracker/active-datatable-server-side', { params });
      setLeads(response.data.data);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error('Error fetching data', error);
    }

    setLoading(false);
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  };  

  const renderHeader = () => {
    return (
      <span className="p-input-icon-left flex align-items-center justify-content-end">
        <InputText className="input-field m-2" style={{ width: '300px' }} type="search" value={globalFilter || ''} onChange={(e) => onSearchFetchData(e.target.value)} placeholder="Search" />
      </span>
    );
  };

  return (
    <>

      <div className="leads-pagination-datatable">

        <div className="flex align-items-center justify-content-between">
          <div className='col flex  p-0'>
            <button type="button" title='LEGENDS Colors Guide' style={{ cursor: 'pointer' }} onClick={() => { console.log('color'); setColorPlatedailog(true) }} className="my-2 customSave-button" >
              <div className='flex items-center gap-2 '>
                <PiPaletteBold size={18} />
                <span >Legends</span>
              </div>
            </button>

            <button type="button" title='Download Active leads in xlxs formate' style={{ cursor: 'pointer' }} onClick={exportExcel} data-pr-tooltip="XLS" outlined className="exce-download-button m-2" >
              <div className='flex items-center  gap-2 px-1'>
                <FaFileExcel size={14} />
                <span > Download Excel </span>
              </div>
            </button>          

          </div>
          <div className='flex'>
            {/* <div>
                {renderHeader()}
              </div>                             */}
            <button type="button" title='Add new Leads' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2 ml-0" >
              <div className='flex items-center gap-2 px-1 '>
                <BiPlusMedical size={14} />
                <span> Add </span>
              </div>
            </button>
          </div>

          {/* <div className="col-4 p-2 m-2 jucstify-content-center">
            <h3>ACTIVES </h3>
          </div>

          <div className="col-3 p-2">
            {renderHeader()}
          </div> */}
        </div>

        <div className="flex align-items-center justify-content-between">
          <div className='col flex  p-0'>
            {/* <button type="button" title='LEGENDS Colors Guide' style={{ cursor: 'pointer' }} onClick={() => { console.log('color'); setColorPlatedailog(true) }} className="my-2 customSave-button" >
              <div className='flex items-center gap-2 '>
                <PiPaletteBold size={18} />
                <span >Legends</span>
              </div>
            </button>

            <button type="button" title='Download Active leads in xlxs formate' style={{ cursor: 'pointer' }} onClick={exportExcel} data-pr-tooltip="XLS" outlined className="exce-download-button m-2" >
              <div className='flex items-center  gap-2 py-1'>
                <FaFileExcel size={14} />
                <span > Download Excel </span>
              </div>
            </button> */}

          </div>
          {/* <div className="col-4 p-2 m-2 jucstify-content-center">
            <h3>ACTIVES </h3>
          </div> */}

            <div className='flex'>
              <div>
                {renderHeader()}
              </div>                            
            </div>
        </div>        

        <Toast ref={toast} />
        {isLoading ? (
          <div className="loading-spinner">
            Loading...
            <div className="spinner"></div>
          </div>
        ) : (
          <div className=''>
            <DataTable
              value={leads}
              lazy
              paginator
              rows={rows}
              first={first}
              totalRecords={totalRecords}
              loading={loading}
              onPage={fetchData}
              onSort={fetchData}
              onFilter={fetchData}
              filters={filters}
              sortField={sortField}
              sortOrder={sortOrder}                
              rowClassName={rowClass} 
              dataKey="id" 
              showHeaders 
              tableStyle={{ minWidth: '50rem', minHeight: '56px' }}
              scrollable 
              scrollHeight="80vh" 
              stripedRows 
              size="small" 
              showGridlines 
              selectionMode="single"
            >
              {/* <DataTable filters={filters} onFilter={(e) => setFilters(e.filters)} value={leads} virtualScrollerOptions={{ itemSize: 46 }} rowClassName={rowClass} dataKey="id" showHeaders tableStyle={{ minWidth: '50rem', minHeight: '600px' }} scrollable scrollHeight="80vh" stripedRows size="small" showGridlines selectionMode="single" > */}
              <Column frozen body={actionBodyTemplate} header="Action" style={{ textAlign: 'center', minWidth: '100px' }} exportable={false}></Column>
              <Column frozen field='client' sortable header="Client" style={{ minWidth: '200px', paddingLeft: '5px', }}></Column>
              <Column field='contact_date' sortable header="contact date" style={{ minWidth: '200px', textAlign:'center' }} body={(e) => dateView(e.contact_date)}  ></Column>
              {/* <Column field='first_name' header="first name" style={{ minWidth: '200px' }} ></Column> */}
              {/* <Column field='last_name' header="last name" style={{ minWidth: '200px' }} ></Column> */}

              {/* <Column field='street_number' header="street number" style={{ minWidth: '200px' }} ></Column> */}
              {/* <Column field='street_name' header="street name" style={{ minWidth: '200px' }} ></Column> */}
              {/* <Column field='city' header="city" style={{ minWidth: '200px' }} ></Column> */}
              {/* <Column field='postal_code' header="postal code" style={{ minWidth: '200px' }} ></Column> */}

              <Column field='address' sortable body={(e) => showTooltip(e.address)} header="Address" style={{ minWidth: '200px', textAlign: 'center' }} ></Column>
              <Column field='email' sortable body={(e) => showTooltip(e.email)} header="email" style={{ minWidth: '200px', textAlign: 'center' }}  ></Column>
              <Column field='phone_number' sortable body={(e) => showTooltip(e.phone_number)} header="phone number" style={{ minWidth: '200px', textAlign: 'center' }} ></Column>
              {/* <Column field='lead_source' sortable body={(e) => showTooltip(e.lead_source)} header="lead source" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}

              <Column field='project_type' sortable body={(e) => showTooltip(e.project_type)} header="project type" style={{ minWidth: '200px', textAlign: 'center' }} ></Column>
              <Column field='project_value' sortable body={(data) => formatCurrency(data.project_value) } header="project value" style={{ minWidth: '200px', textAlign: 'center' }}  ></Column>
              {/* <Column field='project_desc' sortable body={(e) => showTooltip(e.project_desc)} header="project description" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}

              {/* <Column field='declined_type' sortable body={(e) => showTooltip(e.declined_type)} header="declined type" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='site_visit_date' sortable body={(e) => dateView(e.site_visit_date)} header="site visit date" style={{ minWidth: '200px' }} ></Column> */}
              {/* <Column field='site_visit_stage' sortable body={(e) => showTooltip(e.site_visit_stage)} header="site visit stage" style={{ minWidth: '200px', textAlign: 'center' }}  ></Column> */}
              {/* <Column field='contact_to_site_visit_days' sortable body={(e) => showTooltip(e.contact_to_site_visit_days)} header="contact to site visit days" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='ce_sent_out' sortable body={(e) => dateView(e.ce_sent_out)} header="ce sent out" style={{ minWidth: '200px' }}  ></Column> */}
              {/* <Column field='ce_stage' sortable body={(e) => showTooltip(e.ce_stage)} header="ce stage" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='site_visit_to_ce_days' sortable body={(e) => showTooltip(e.site_visit_to_ce_days)} header="site visit to ce days" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='fsa_date' sortable header="fsa date" body={(e) => dateView(e.fsa_date)} style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='fsa_stage' sortable body={(e) => showTooltip(e.fsa_stage)} header="fsa stage" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='ce_to_fsa_days' sortable body={(e) => showTooltip(e.ce_to_fsa_days)} header="ce to fsa days" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='contract_date' sortable header="contract date" body={(e) => dateView(e.contract_date)} style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='contract_stage' sortable body={(e) => showTooltip(e.contract_stage)} header="contract stage" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='fsa_to_contract_days' sortable body={(e) => showTooltip(e.fsa_to_contract_days)} header="fsa to contract days" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='construction_start_date' sortable header="construction start date" body={(e) => dateView(e.construction_start_date)} style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='construction_start_stage' sortable body={(e) => showTooltip(e.construction_start_stage)} header="construction start stage" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='construction_to_start_days' sortable body={(e) => showTooltip(e.construction_to_start_days)} header="construction to start days" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='completion_date' sortable header="completion date" body={(e) => dateView(e.completion_date)} style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='completion_stage' sortable body={(e) => showTooltip(e.completion_stage)} header="completion stage" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='completion_to_construction_days' sortable body={(e) => showTooltip(e.completion_to_construction_days)} header="completion to construction days" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='cilentInformation' sortable body={(e) => showTooltip(e.cilentInformation)} header="cilent Information" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='notes' sortable body={(e) => showTooltip(e.notes)} header="notes" style={{ minWidth: '220px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='sr_pm_notes' sortable body={(e) => showTooltip(e.sr_pm_notes)} header="sr pm notes" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}
              {/* <Column field='vp_of_construction_comments' sortable body={(e) => showTooltip(e.vp_of_construction_comments)} header="vp of construction comments" style={{ minWidth: '200px', textAlign: 'center' }} ></Column> */}

            </DataTable>
          </div>
        )}
      </div>
      {/* // --------------------------------dialog Box------------------------------------------------------ */}

      {isModalOpen && <LeadModel lead={editLeadList} onClose={closeLeadModel} onDataRefresh={handleDataRefreshLeadModel} />}
      {/* // ---------------------------Delete-Modals------------------------------------------------------------------------------ */}

      {isDeleteConfirmationModalOpen && (
        <div className="modal">
          <div className="small-modal-content">
            <div className="modal-headerx">
              <h5 className="modal-title">Delete Confirmation</h5>
              <button className="modal-closex" onClick={() => setIsDeleteConfirmationModalOpen(false)} >
                &times;
              </button>
            </div>
            <div className="modal-bodyx">
              <p>{projectDeletetitle}</p>
            </div>
            <div className="modal-footer-cancelx">
              <button title='Cancel' className="cancel-buttonx" onClick={() => setIsDeleteConfirmationModalOpen(false)}>
                Cancel
              </button>
              <button title='Confirm Delete' className="delete-buttonx" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---------------------------Color Plate-Modals------------------------------------------------------------------------------ */}

      <Dialog header="" visible={colorPlatedailog} maximizable style={{ width: '500px' }} dismissableMask="true" onHide={() => setColorPlatedailog(false)}>

        <div className='card'>

          {CommonService.getColorDeclarationComponent()}

        </div>
      </Dialog>


    </>

  )
}

export default Actives
